module.exports = "<ng-container #container></ng-container>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/dynamic-content-form/dynamic-content-form.component.html
// module id = ./src/app/forms/dynamic-content-form/dynamic-content-form.component.html
// module chunks = main